var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreatePostCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "#2E3A59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 44C24.8355 44 21.7421 43.0616 19.1109 41.3035C16.4797 39.5454 14.4289 37.0466 13.2179 34.1229C12.0069 31.1993 11.6901 27.9823 12.3074 24.8786C12.9248 21.7749 14.4487 18.9239 16.6863 16.6863C18.9239 14.4487 21.7749 12.9248 24.8786 12.3074C27.9823 11.6901 31.1993 12.0069 34.1229 13.2179C37.0466 14.4289 39.5454 16.4797 41.3035 19.1109C43.0616 21.7421 44 24.8355 44 28C44 32.2435 42.3143 36.3131 39.3137 39.3137C36.3131 42.3143 32.2435 44 28 44ZM28 14.9091C25.4109 14.9091 22.8799 15.6769 20.7271 17.1153C18.5743 18.5538 16.8964 20.5983 15.9056 22.9903C14.9148 25.3824 14.6555 28.0145 15.1606 30.5539C15.6658 33.0933 16.9125 35.4259 18.7433 37.2567C20.5741 39.0875 22.9067 40.3343 25.4461 40.8394C27.9855 41.3445 30.6176 41.0853 33.0097 40.0944C35.4017 39.1036 37.4463 37.4257 38.8847 35.2729C40.3231 33.1201 41.0909 30.5891 41.0909 28C41.0909 24.5281 39.7117 21.1984 37.2567 18.7433C34.8017 16.2883 31.4719 14.9091 28 14.9091Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.272 26.5452H29.4538V20.7271H26.5447V26.5452H20.7266V29.4543H26.5447V35.2725H29.4538V29.4543H35.272V26.5452Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePostCalendarIcon);
export default __webpack_public_path__ + "static/media/create-post-calendar-icon.a2e37ff7.svg";
export { ForwardRef as ReactComponent };